import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';
import type { SendNotificationRequest } from '../types/notificationCenter';

/**
 * POST /api/eraf/notification-center/send — 신규 알림 발송 (NOTIFICATION_SEND)
 * 성공 시 목록 + 통계 캐시 무효화
 */
export function useSendNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: SendNotificationRequest) => notificationCenterApi.send(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['notification-center', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['notification-center', 'stats'] });
    },
  });
}
